import { AppStates } from "@/models/AppStates";
import { AppUsers } from "@/models/AppUsers";
import jQuery from "jquery"
import { MyUrls } from "./MyWorkUrls";
Object.assign(window, { $: jQuery, jQuery })

export const myDataSyncUrl = MyUrls.getDataSync();//"V1/rest/web/datasyncs";//"https://emmie-backend.offis.de/rest/datasync"; https://10.49.36.178

export const myDataSyncXMLHTTPRequests = {

    

    async sendToMyServer(dataArray: any, myKnownServerIds: any){
        return await AppUsers.getMyUser().then((user) => {
            console.log('sendToMyServer before Promise')
            return new Promise((resolve,reject) => {
                var data = "what=simpleDataSync&userId="+user.sysId+"&datas="+encodeURIComponent(JSON.stringify(dataArray))+"&myKnownServerIds="+encodeURIComponent(JSON.stringify(myKnownServerIds));
               
                var xhr = new XMLHttpRequest();
                xhr.withCredentials = true;

               // xhr.addEventListener("readystatechange", function() {
               //     console.log(this)
               //     if(this.status == 401){
               //         reject('unauthorized');
               //     }
               //     if(this.readyState === 4) {
               //         console.log(this)
               //         resolve(this.responseText);
               //     }
               // });
                xhr.addEventListener("abort", (event) => {
                    console.log("abort")
                });
                xhr.addEventListener("error", (event) => {
                    console.log("error")
                });
                xhr.addEventListener("progress", (event) => {
                    console.log("progress")
                });
                xhr.addEventListener("timeout", (event) => {
                    console.log("timeout")
                });
                xhr.timeout = 360000;

                xhr.ontimeout = (e) => {
                    console.log("timeout")
                    reject('timeout');
                };
                xhr.onload = (e) => {
                    console.log("timeout ok")
                    if(xhr.status == 401){
                        reject('unauthorized');
                    }
                    if(xhr.readyState === 4) {
                        console.log(xhr)
                        resolve(xhr.responseText);
                    }
                };

                xhr.open("POST", myDataSyncUrl, true);
                xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                xhr.send(data);

                console.log('Promise data send')
            });
        })
    },
}